import store from 'utils/store/withMiddleware'

/**
 * Intended to use for small changes to the global state
 * @param agents
 * @param newValues
 */
export const customState = (agents: number[], newValues: unknown) => {
  const state = store.getState()
  if (!agents.includes(state.hcStorage.agent_id)) return

  store.update(newValues, true)
}
